module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "boxi"
  }, [_c('p', {
    staticClass: "fm-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('b', [_vm._v("introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("I love to celebrate the changing seasons, and fall has always been a favorite. This book contains a collection of pieced and appliquéd projects for fall that are perfect for decorating your home or for gift giving. There are projects to carry you from Halloween all through the fall season.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Whether you are a first-time sewist or an experienced quilter, there are projects in this book that are appropriate for your skill level. The designs use machine appliqué and simple piecing techniques. There are lap quilts, wall quilts, table toppers, runners, place mats, and towels. I hope this collection of projects will inspire you to create and to celebrate the season.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148fa20e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Introduction.vue
// module id = 66
// module chunks = 0